import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ValidationMessage from '@/js/components/common/ValidationMessage';

//MultiToggle Class
class MultiToggleButton extends React.PureComponent {
	constructor(props) {
		super(props);

		this.onBlur = this.onBlur.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.size = this.props.tabs.length;

		/* which label is focused */
		this.state = {};
		for(let _i=0; _i<this.size; _i++){
			this.state[this.props.tabs[_i].toLowerCase() + "Focused"] = false;
		}
	}

	onBlur(_btn) {
		let _newState={};
		for(let _i=0; _i<this.size; _i++) {
			let _name = this.props.tabs[_i].toLowerCase()+"Focused";
			_newState[ _name ] = (_i==_btn) ? false : this.state[_name];
		}
		this.setState(_newState);
	}

	onFocus(_btn) {
		let _newState={};
		for(let _i=0; _i<this.size; _i++) {
			_newState[ this.props.tabs[_i].toLowerCase()+"Focused" ] = (_i==_btn) ? true : false;
		}
		this.setState(_newState);
	}

	render() {
		return (
			<fieldset className="MultiToggleButton">
				<div className="d-flex align-items-center justify-content-between">
					<legend className="col-form-label">{this.props.label}</legend>
					<div className={cx("btn-group", "btn-group-toggle", (this.props.errorMessage ? "tropic-invalid" : ""))}>
						{/*the actual radio button input is hidden (so that it receives keyboard tabbing, and maintains display: inline while still maintaining the look of the label vs html circular radios */}
						{/* first label gets a bootstrap focus class if yesFocused or noFocused */}
						{ this.props.tabs.map((n,i) =>
							<ButtonIndividual
								key={i}
								label={n}
								index={i}
								aval={this.props.value}
								onBlur={this.onBlur}
								onFocus={this.onFocus}
								onChange={this.props.onChange}
								parentState={this.state}
								showRadioButton={this.props.showRadioButtons}
								></ButtonIndividual>
								)}
					</div>
				</div>
				{this.props.errorMessage &&
					<ValidationMessage message={this.props.errorMessage}/>
				}
			</fieldset>
		);
	}
}

class ButtonIndividual extends React.PureComponent {
	constructor(props) {
		super(props);
		this.onChange = props.onChange;
		this.onBlur = props.onBlur.bind(this);
		this.onFocus = props.onFocus.bind(this);
	}

	render() {
		/* activeVal determines which button out of the list is currently selected */
		/* value should initially be undefined */
		let activeVal = undefined;
		if(this.props.aval !== undefined) activeVal = this.props.aval;

		return (
				<label className={cx('btn', 'btn-sm', 'btn-primary', `toggleButton${this.props.index}`,
					{focus: this.props.parentState[this.props.label.toLowerCase() + "Focused"], active: (activeVal === this.props.label)}
				)}
				>
					<input onChange={e => this.onChange(this.props.label)}
						type="radio"
						name="button"
						autoComplete="off"
						value={this.props.index}
						onFocus={e => this.onFocus(this.props.index)}
						onBlur={e => this.onBlur(this.props.index)}
						hidden={!this.props.showRadioButton}
						>
					</input>
					{this.props.label}
				</label>
		);
	}
}

ButtonIndividual.propTypes = {
	label: PropTypes.string,
	index: PropTypes.number,
	aval: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	onBlur: PropTypes.func.isRequired,
	onFocus: PropTypes.func.isRequired,
	parentState: PropTypes.object,
	showRadioButton: PropTypes.bool
};

MultiToggleButton.propTypes = {
	value: PropTypes.string,
	name: PropTypes.string,
	tabs: PropTypes.array,
	label: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	errorMessage: PropTypes.string.isRequired,
	showRadioButtons: PropTypes.bool
};

MultiToggleButton.defaultProps = {
	showRadioButtons: true
};

export default MultiToggleButton;
